module.exports = __webpack_public_path__ + "img/sergeant-service-icon2.416b3dde.png";